export default "__VITE_PUBLIC_ASSET__1524779c__"